export { default } from './dist/vue-virtual-scroller'
export * from './dist/vue-virtual-scroller'
import './dist/vue-virtual-scroller.css'



// WEBPACK FOOTER //
// ./~/vue-virtual-scroller/index.js